import ReactDOM from 'react-dom/client';
import App from './App';
import { CustomToastContainer } from './components/ui/custom-toast';
import './index.css';
import { ToastProvider } from './lib/toast-context';
import reportWebVitals from './reportWebVitals';
// import { Toaster } from './components/ui/toaster';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
  <ToastProvider>
    <App />
    <CustomToastContainer />
  </ToastProvider>
  
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
